import React, { useState, useRef, useEffect } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FiEdit2 } from "react-icons/fi";
import { FiXCircle } from "react-icons/fi";

const Dropdown = (props) => {
  const index = props.data
  const drugs = props.drugsData
  const setDrugs = props.setDrugsData
  const currentDrug = props.curr
  const setCurrentDrug = props.setCurr
  const setDrugIndex = props.setindex
  const setEditingMode = props.setedit
  const setisAddingDrug = props.setisAddingDrug
  // const [drugs, setDrugs] = useState([]);

  const [showDropdown, setShowDropdown] = useState(false);
  const toggleDropdown = (e) => {
    e.preventDefault()
    setShowDropdown(!showDropdown);
  };

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDeleteDrug = (data) => {
    const updatedDrugs = drugs.filter((_, i) => i !== data);
    // alert(data)
    setDrugs(updatedDrugs);
  };
  const handleEditDrug = (index) => {
    setDrugIndex(index); // Set the index of the drug being edited
    setCurrentDrug(drugs[index]); // Set the current drug for editing
    setEditingMode(true);
    setisAddingDrug(true)
    setShowDropdown(false);
  };

  return (
    <div className={`td_btn dropdown-container ${props.className}`} >
      <button onClick={toggleDropdown} className="dot-button">
        <BsThreeDotsVertical />
      </button>
      {showDropdown && (
        <div
          ref={dropdownRef}
          className="dropdown-content show-dropdown"
        >

          <button onClick={() => handleEditDrug(index)}>

            <span> <FiEdit2 className="text-green-800" /> </span> Edit details
          </button>
          <button onClick={() => handleDeleteDrug(index)}>
            <span>
              <FiXCircle className="text-red-800" />
            </span>
            Delete
          </button>
        </div>
      )}
    </div>
  );
}

export default Dropdown;